import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export function getEnrichmentTypeFromObjectTypeId(objectTypeId) {
  if (objectTypeId === CONTACT_TYPE_ID) {
    return 'contact';
  }
  return 'company';
}